var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack3Solid10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,3.88a2.16,2.16,0,0,1,1.79.81,5.25,5.25,0,0,1,.77,3.21,5.18,5.18,0,0,1-.78,3.21A2.13,2.13,0,0,1,8,11.92,2.25,2.25,0,0,1,6.11,11,5.21,5.21,0,0,1,5.4,7.88a5.17,5.17,0,0,1,.78-3.2A2.15,2.15,0,0,1,8,3.88ZM8,5.13a.79.79,0,0,0-.49.17,1.24,1.24,0,0,0-.33.63A8.24,8.24,0,0,0,7,7.9a8.7,8.7,0,0,0,.14,1.9,1.29,1.29,0,0,0,.35.69.76.76,0,0,0,.49.18.74.74,0,0,0,.49-.18,1.2,1.2,0,0,0,.33-.62,8.24,8.24,0,0,0,.16-2A8.7,8.7,0,0,0,8.8,6a1.45,1.45,0,0,0-.35-.7A.81.81,0,0,0,8,5.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack3Solid10);
export default __webpack_public_path__ + "static/media/Symbolpack_3_solid_10.f6ae94cde884d31405288993f06a623d.svg";
export { ForwardRef as ReactComponent };